import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=2a0a5083&scoped=true"
import script from "./ProductSelector.vue?vue&type=script&lang=js"
export * from "./ProductSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductSelector.vue?vue&type=style&index=0&id=2a0a5083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a5083",
  null
  
)

export default component.exports